import { EntityFilterRow } from 'components/eventView/filters/EntityFilterRow';
import { EventViewMapPageContent } from 'components/eventView/pages/EVMapPageContent';
import { SplitTitle } from 'components/guide/split/SplitTitle';
import { EVariables } from 'libs/styles/styling';
import { EVPcScrollAnchors } from 'pages/EventViewPage/EventViewPagePC/eVScrollAnchors';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVMapPagePC = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);

    return (
        <S_EVMapPagePC className={props.className} id={EVPcScrollAnchors.Map}>
            <S_SplitTitle title={Localization.INTERACTIVE_MAP} />
            {ctxEventView.categories?.length > 0 && <S_FilterRow entityId="map" isWide={true} />}
            <S_EVMapPageContent />
        </S_EVMapPagePC>
    );
};

const S_EVMapPagePC = styled.div``;

const S_EVMapPageContent = styled(EventViewMapPageContent)`
    width: 100%;
    height: 600px;
    border-radius: ${EVariables.Radius2};
    overflow: hidden;
`;

const S_FilterRow = styled(EntityFilterRow)`
    position: relative;
    z-index: 2;
`;

const S_SplitTitle = styled(SplitTitle)`
    margin: 60px 0 60px 0;
`;
